import { getLocale } from '../translations/translator';
import { UNAUTHORIZED } from 'http-status';
import LwtApi, { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { Header } from '@lwtears/lwt-common-frontend/lib/@common/util/header-util';
import { hasAuthCookies, removeAuthCookies } from '../util/auth-cookie-util';

export * from './book';
export * from './click-away';
export * from './telemetry';
export * from './resource';
export * from './user';
export * from './email';
export * from './tour';
export * from './assignment';

const getHeaders = () => ({ [Header.LOCALE]: getLocale() });

const Api = LwtApi()
  .addDefaultAuthStrategy(
    hasAuthCookies() ? AuthStrategy.AUTH_TOKEN : AuthStrategy.HTTP_AUTHENTICATION
  )
  .addHeaders(getHeaders)
  .options({ throwErrors: true })
  .onError(error => {
    if ([UNAUTHORIZED].includes(error?.status) && hasAuthCookies()) {
      removeAuthCookies();
      window.location.reload();
      return;
    }

    throw error;
  });

export default Api;
